import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Trophy } from 'lucide-react';

export default function OlympicTimeline({ games }) {
  if (!games || games.length === 0) return null;

  return (
    <div className="relative">
      {/* Vertical line */}
      <div className="absolute left-4 top-0 bottom-0 w-px bg-gradient-to-b from-blue-400 via-blue-400 to-transparent" />

      <div className="space-y-6">
        {games.map((game, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.15 }}
            className="relative pl-12"
          >
            {/* Dot on timeline */}
            <div className="absolute left-2 top-2 w-5 h-5 rounded-full bg-[#0a1628] border-2 border-blue-400 flex items-center justify-center">
              <div className="w-2 h-2 rounded-full bg-blue-400" />
            </div>

            {/* Content card */}
            <div className="bg-[#0f2847]/50 backdrop-blur-sm rounded-xl p-4 border border-blue-900/30 hover:border-blue-400/30 transition-colors">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-2xl font-bold text-white">{game.year}</span>
                <div className="flex items-center gap-1 text-blue-300 text-sm">
                  <MapPin className="w-3 h-3" />
                  {game.location}
                </div>
              </div>
              
              {game.results && (
                <div className="flex items-start gap-2 text-blue-100 text-sm">
                  <Trophy className="w-4 h-4 text-[#d4af37] mt-0.5 flex-shrink-0" />
                  <p>{game.results}</p>
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}